<div class="fade-in">
  <div class="content-section">
    <div class="section-header">
      <h2>Company Management</h2>
      <button class="primary-btn" (click)="openAddModal()">+ Add Company</button>
    </div>

    <!-- Modal Form for Add/Edit -->
    <div class="modal-overlay" *ngIf="isModalOpen">
      <div class="modal-content fade-in" [class.saving-mode]="isSaving">
      
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <h3 class="modal-title" style="margin-bottom: 0;">
          {{ editingId ? 'Edit Company' : 'Add New Company' }}
        </h3>
        <div style="display: flex; align-items: center; gap: 16px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" [(ngModel)]="newCompany.isFeeCollection" [disabled]="isSaving || checkIfFeeCollectionDisabled()" id="isFeeCollection" class="company-checkbox" style="margin: 0; cursor: pointer;">
            <label for="isFeeCollection" style="margin: 0; cursor: pointer; font-size: 0.9rem; font-weight: 600; color: #334155;" [style.opacity]="checkIfFeeCollectionDisabled() ? '0.5' : '1'" [title]="checkIfFeeCollectionDisabled() ? 'A Fee Collection company is already set for the ' + getBrandName(newCompany.brand) + ' brand.' : ''">Fee Collection</label>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" [(ngModel)]="newCompany.sis" [disabled]="isSaving" id="sis" class="company-checkbox" style="margin: 0; cursor: pointer;">
            <label for="sis" style="margin: 0; cursor: pointer; font-size: 0.9rem; font-weight: 600; color: #334155;">Shop In Shop (SIS)</label>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" [(ngModel)]="newCompany.brokerReport" [disabled]="isSaving" id="brokerReport" class="company-checkbox" style="margin: 0; cursor: pointer;">
            <label for="brokerReport" style="margin: 0; cursor: pointer; font-size: 0.9rem; font-weight: 600; color: #334155;">Broker Report</label>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" [(ngModel)]="newCompany.kcegOwned" [disabled]="isSaving" id="kcegOwned" class="company-checkbox" style="margin: 0; cursor: pointer;">
            <label for="kcegOwned" style="margin: 0; cursor: pointer; font-size: 0.9rem; font-weight: 600; color: #334155;">KCEG Owned</label>
          </div>
        </div>
      </div>
      
      <div class="form-grid">
        <div class="form-group">
          <label>Company Name *</label>
          <input [(ngModel)]="newCompany.company" [disabled]="isSaving" placeholder="Company Inc." class="form-input">
        </div>
        <div class="form-group">
          <label>Brand *</label>
          <select [(ngModel)]="newCompany.brand" [disabled]="isSaving" class="form-select">
            <option value="" disabled>Select Brand</option>
            <option *ngFor="let brand of brands$ | async" [value]="brand.id">{{ brand.name }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>POC Name *</label>
          <input [(ngModel)]="newCompany.pocName" [disabled]="isSaving" placeholder="John Doe" class="form-input">
        </div>
        <div class="form-group">
          <label>Email * <span style="font-weight: normal; font-size: 0.75rem;">(comma separated)</span></label>
          <input [(ngModel)]="newCompany.email" [disabled]="isSaving" placeholder="john@example.com" class="form-input">
        </div>
        <div class="form-group">
          <label>Mall Contact Email <span style="font-weight: normal; font-size: 0.75rem;">(comma separated)</span></label>
          <input [(ngModel)]="newCompany.mallEmail" [disabled]="isSaving" placeholder="mall@example.com" class="form-input">
        </div>
        <div class="form-group">
          <label>Phone</label>
          <input [(ngModel)]="newCompany.phone" [disabled]="isSaving" placeholder="(555) 123-4567" class="form-input">
        </div>
        <div class="form-group">
          <label>EIN</label>
          <input [(ngModel)]="newCompany.ein" [disabled]="isSaving" placeholder="XX-XXXXXXX" class="form-input">
        </div>
        <div class="form-group">
          <label>Fedex Number</label>
          <input [(ngModel)]="newCompany.fedexNumber" [disabled]="isSaving" placeholder="Account #" class="form-input">
        </div>
        <div class="form-group">
          <label>Sales Tax % *</label>
          <input type="number" step="0.01" [(ngModel)]="newCompany.salesTax" [disabled]="isSaving" placeholder="0.00" class="form-input">
        </div>
        <div class="form-group">
          <label>Reserve %</label>
          <input type="number" step="0.01" [(ngModel)]="newCompany.reserveRate" [disabled]="isSaving" placeholder="0.00" class="form-input">
        </div>
        <div class="form-group full-width">
          <label>Address</label>
          <input [(ngModel)]="newCompany.address" [disabled]="isSaving" placeholder="123 Business Rd, City, State" class="form-input">
        </div>
      </div>

      <!-- SIS Rates Section -->
      <div class="modal-section" *ngIf="newCompany.sis">
        <div class="section-toggle" (click)="isSisRatesExpanded = !isSisRatesExpanded">
          <h4 class="section-title">SIS Rates</h4>
          <span class="chevron" [class.expanded]="isSisRatesExpanded">▶</span>
        </div>
        
        <div *ngIf="isSisRatesExpanded" class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label>CC Rate %</label>
              <input type="number" step="0.01" [(ngModel)]="newCompany.sisCcRate" [disabled]="isSaving" placeholder="0.00" class="form-input">
            </div>
            <div class="form-group">
              <label>Profit Share %</label>
              <input type="number" step="0.01" [(ngModel)]="newCompany.sisProfitShare" [disabled]="isSaving" placeholder="0.00" class="form-input">
            </div>
          </div>
        </div>
      </div>

      <!-- Broker Report Section -->
      <div class="modal-section" *ngIf="newCompany.brokerReport">
        <div class="section-toggle" (click)="isBrokerReportExpanded = !isBrokerReportExpanded">
          <h4 class="section-title">Broker Report Settings</h4>
          <span class="chevron" [class.expanded]="isBrokerReportExpanded">▶</span>
        </div>
        
        <div *ngIf="isBrokerReportExpanded" class="section-content">
          <div class="form-grid">
            <div class="form-group">
              <label>Broker Name</label>
              <input [(ngModel)]="newCompany.brokerName" [disabled]="isSaving" placeholder="Broker Name" class="form-input">
            </div>
            <div class="form-group full-width">
              <label>Location</label>
              <input [(ngModel)]="newCompany.brokerLocation" [disabled]="isSaving" placeholder="Broker Address/Location" class="form-input">
            </div>
            <div class="form-group">
              <label>CC Rate %</label>
              <input type="number" step="0.01" [(ngModel)]="newCompany.brokerCcRate" [disabled]="isSaving" placeholder="0.00" class="form-input">
            </div>
            <div class="form-group">
              <label>Profit Share %</label>
              <input type="number" step="0.01" [(ngModel)]="newCompany.brokerProfitShare" [disabled]="isSaving" placeholder="0.00" class="form-input">
            </div>
          </div>
        </div>
      </div>

      <!-- Adjustments Section -->
      <div class="modal-section">
        <div class="section-toggle" (click)="isAdjustmentsExpanded = !isAdjustmentsExpanded">
          <h4 class="section-title">Adjustments</h4>
          <span class="chevron" [class.expanded]="isAdjustmentsExpanded">▶</span>
        </div>
        
        <div *ngIf="isAdjustmentsExpanded" class="section-content">
          <div class="ownership-form-row">
            <div class="input-group flex-2">
              <input [(ngModel)]="newAdjustment.description" [disabled]="isSaving" placeholder="Adjustment Description" class="form-input">
            </div>
            <div class="input-group flex-1">
              <input type="number" step="0.01" [(ngModel)]="newAdjustment.amount" [disabled]="isSaving" placeholder="Amount" class="form-input">
            </div>
            <button (click)="addAdjustment()" [disabled]="isSaving" class="mini-btn tall">Add</button>
          </div>

          <table class="ownership-table" *ngIf="currentAdjustments.length || tempAdjustments.length; else noAdjustments">
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (editingId ? currentAdjustments : tempAdjustments); let i = index">
                <td><input [(ngModel)]="item.description" [disabled]="isSaving" class="form-input" style="padding: 4px;"></td>
                <td><input type="number" step="0.01" [(ngModel)]="item.amount" [disabled]="isSaving" class="grid-input" style="width: 100%; box-sizing: border-box;"></td>
                <td class="text-center">
                  <button (click)="deleteAdjustment(i)" [disabled]="isSaving" class="icon-btn danger" title="Delete">🗑️</button>
                </td>
              </tr>
            </tbody>
          </table>
          <ng-template #noAdjustments>
            <div class="empty-state">No adjustments added.</div>
          </ng-template>
        </div>
      </div>

      <!-- Ownership Section (Only visible when editing) -->
      <div class="modal-section">
        <div class="section-toggle" (click)="isOwnershipExpanded = !isOwnershipExpanded">
          <h4 class="section-title">Ownership & Profit Share</h4>
          <span class="chevron" [class.expanded]="isOwnershipExpanded">▶</span>
        </div>
        
        <!-- Add Ownership Form -->
        <div *ngIf="isOwnershipExpanded" class="section-content">
        <div *ngIf="ownershipErrorMessage" class="error-message mb">
          {{ ownershipErrorMessage }}
        </div>

        <div class="ownership-form-row">
          <select [(ngModel)]="newOwnership.ownerId" [disabled]="isSaving" class="form-select flex-2">
            <option value="" disabled>Select Owner</option>
            <option *ngFor="let owner of owners$ | async" [value]="owner.id">{{ owner.name }}</option>
          </select>
          <div class="input-group flex-1">
            <input type="number" [(ngModel)]="newOwnership.ownershipPercent" [disabled]="isSaving" placeholder="Ownership %" class="form-input">
            <span class="suffix">% Own</span>
          </div>
          <div class="input-group flex-1">
            <input type="number" [(ngModel)]="newOwnership.profitSharePercent" [disabled]="isSaving" placeholder="Profit %" class="form-input">
            <span class="suffix">% Profit</span>
          </div>
          <button (click)="addOwnership()" [disabled]="isSaving" class="mini-btn tall">Add</button>
        </div>

        <!-- Ownership Grid -->
        <table class="ownership-table" *ngIf="currentOwnerships.length || tempOwnerships.length; else noOwnerships">
          <thead>
            <tr>
              <th>Owner Name</th>
              <th>Ownership %</th>
              <th>Profit Share %</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="editingId">
            <tr *ngFor="let item of currentOwnerships">
              <td class="text-subtle">{{ getOwnerName(item.ownerId) }}</td>
              <td><input type="number" [(ngModel)]="item.ownershipPercent" [disabled]="isSaving" class="grid-input"></td>
              <td><input type="number" [(ngModel)]="item.profitSharePercent" [disabled]="isSaving" class="grid-input"></td>
              <td class="text-center">
                <button (click)="deleteOwnership(item.id)" [disabled]="isSaving" class="icon-btn danger" title="Delete">🗑️</button>
              </td>
            </tr>
            </ng-container>

            <ng-container *ngIf="!editingId">
              <tr *ngFor="let item of tempOwnerships; let i = index">
                <td class="text-subtle">{{ getOwnerName(item.ownerId) }}</td>
                <td><input type="number" [(ngModel)]="item.ownershipPercent" [disabled]="isSaving" class="grid-input"></td>
                <td><input type="number" [(ngModel)]="item.profitSharePercent" [disabled]="isSaving" class="grid-input"></td>
                <td class="text-center">
                  <button (click)="deleteOwnership(null, i)" [disabled]="isSaving" class="icon-btn danger" title="Delete">🗑️</button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <ng-template #noOwnerships>
          <div class="empty-state">No ownership records added.</div>
        </ng-template>
        </div>
      </div>

      <!-- Stores Section -->
      <div class="modal-section">
        <div class="section-toggle" (click)="isStoresExpanded = !isStoresExpanded">
          <h4 class="section-title">Stores</h4>
          <span class="chevron" [class.expanded]="isStoresExpanded">▶</span>
        </div>
        
        <div *ngIf="isStoresExpanded" class="section-content">
        <div class="ownership-form-row">
          <select [(ngModel)]="newModalStore.id" [disabled]="isSaving" class="form-select flex-3">
            <option value="" disabled>Select Store</option>
            <option *ngFor="let store of availableStores" [value]="store.id">[{{ store.storeId }}] {{ store.name }}</option>
          </select>
          <button (click)="addStoreToModal()" [disabled]="isSaving" class="mini-btn tall">Add</button>
        </div>

        <table class="ownership-table" *ngIf="currentStores.length || tempStores.length; else noStores">
          <thead>
            <tr>
              <th>Store ID</th>
              <th>Store Name</th>
              <th>Location</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let store of (editingId ? currentStores : tempStores); let i = index">
              <td>{{ store.storeId }}</td>
              <td>{{ store.name }}</td>
              <td>{{ store.location }}</td>
              <td class="text-center">
                <button (click)="deleteStoreFromModal(store.id || null, i)" [disabled]="isSaving" class="icon-btn danger" title="Delete">🗑️</button>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noStores>
          <div class="empty-state">No stores are added.</div>
        </ng-template>
        </div>
      </div>

      <div class="modal-actions">
        <div *ngIf="errorMessage" class="error-message mr-auto">
          {{ errorMessage }}
        </div>
        <div *ngIf="generalErrorMessage" class="error-message">
          {{ generalErrorMessage }}
        </div>
        <button *ngIf="editingId" class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
        <button class="primary-btn" (click)="saveCompany()" [disabled]="isSaving">
          <span *ngIf="isSaving" class="spinner-small"></span>
          <span>{{ editingId ? 'Update Company' : 'Add Company' }}</span>
        </button>
      </div>
      
      </div>
    </div>

    <!-- Client List Table -->
    <div class="table-container">
      <table class="ledger-table">
        <thead>
          <tr>
            <th class="col-icon"></th>
            <th class="sortable" (click)="onSort('company')">
              Company <span *ngIf="sortColumn === 'company'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('brand')">
              Brand <span *ngIf="sortColumn === 'brand'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('pocName')">
              POC Name <span *ngIf="sortColumn === 'pocName'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('email')">
              Email <span *ngIf="sortColumn === 'email'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('phone')">
              Phone <span *ngIf="sortColumn === 'phone'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-right sortable" (click)="onSort('salesTax')">
              Sales Tax % <span *ngIf="sortColumn === 'salesTax'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-right sortable" (click)="onSort('reserveRate')">
              Reserve % <span *ngIf="sortColumn === 'reserveRate'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center sortable" (click)="onSort('kcegOwned')">
              KCEG Owned <span *ngIf="sortColumn === 'kcegOwned'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center sortable" (click)="onSort('isFeeCollection')">
              Fee Collection <span *ngIf="sortColumn === 'isFeeCollection'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center sortable" (click)="onSort('sis')">
              SIS <span *ngIf="sortColumn === 'sis'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center sortable" (click)="onSort('brokerReport')">
              Broker Report <span *ngIf="sortColumn === 'brokerReport'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let company of companies">
          <tr>
            <td class="text-center">
              <button class="icon-btn chevron" [class.expanded]="expandedCompanyId === company.id" (click)="toggleExpand(company.id)">
                ▶
              </button>
            </td>
            <td class="company-name">{{ company.company }}</td>
            <td class="text-secondary">{{ getBrandName(company.brand) }}</td>
            <td class="text-secondary">{{ company.pocName }}</td>
            <td class="text-secondary col-email" [title]="company.email || ''">
              <span class="email-ellipsis">{{ company.email }}</span>
            </td>
            <td class="text-secondary">{{ company.phone }}</td>
            <td class="text-right">{{ company.salesTax || 0 }}%</td>
            <td class="text-right">{{ company.reserveRate || 0 }}%</td>
            <td class="text-center">
              <input type="checkbox" class="company-checkbox" [checked]="company.kcegOwned" disabled>
            </td>
            <td class="text-center">
              <input type="checkbox" class="company-checkbox" [checked]="company.isFeeCollection" disabled>
            </td>
            <td class="text-center">
              <input type="checkbox" class="company-checkbox" [checked]="company.sis" disabled>
            </td>
            <td class="text-center">
              <input type="checkbox" class="company-checkbox" [checked]="company.brokerReport" disabled>
            </td>
            <td class="text-center">
              <button class="icon-action-btn mr" (click)="editCompany(company)" title="Edit">✏️</button>
              <button class="icon-action-btn mr" (click)="openUploadModal(company)" title="Manage Files">📁</button>
              <button class="icon-action-btn" (click)="deleteCompany(company.id)" title="Delete">🗑️</button>
            </td>
          </tr>
          
          <!-- Expanded Sub-row -->
          <tr *ngIf="expandedCompanyId === company.id" class="expanded-row">
            <td colspan="11" class="p-0">
              <div class="sub-table-container">
                
                <h4 class="sub-table-title">Ownership</h4>
                <table class="sub-table spaced">
                  <thead>
                    <tr>
                      <th>Owner Name</th>
                      <th>Ownership %</th>
                      <th>Profit Share %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of companyOwnerships$ | async">
                      <td>{{ getOwnerName(item.ownerId) }}</td>
                      <td>{{ item.ownershipPercent }}%</td>
                      <td>{{ item.profitSharePercent }}%</td>
                    </tr>
                    <tr *ngIf="(companyOwnerships$ | async)?.length === 0">
                      <td colspan="3" class="empty-state">No ownership records found.</td>
                    </tr>
                  </tbody>
                </table>

                <div class="divider"></div>

                <h4 class="sub-table-title">Associated Stores</h4>
                <table class="sub-table">
                  <thead>
                    <tr>
                      <th>Store ID</th>
                      <th>Store Name</th>
                      <th>Location</th>
                      <th class="col-actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let store of companyStores$ | async">
                    <td>{{ store.storeId }}</td>
                    <td>{{ store.name }}</td>
                    <td>{{ store.location }}</td>
                  </tr>
                  <tr *ngIf="(companyStores$ | async)?.length === 0">
                    <td colspan="4" class="empty-state">No stores added yet.</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          </ng-container>

          <tr *ngIf="companies.length === 0">
            <td colspan="11" class="empty-state-large">
              No companies found. Add a new company above.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- File Upload Modal -->
<div class="modal-overlay" *ngIf="isUploadModalOpen" (click)="closeUploadModal()">
  <div class="modal-content upload-modal-content" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h3 class="modal-title" style="margin-bottom: 0;">Manage Files</h3>
      <button class="close-btn-static" (click)="closeUploadModal()" [disabled]="uploadingFile">&times;</button>
    </div>
    
    <div class="modal-body scrollable-modal-body">
      <p class="upload-modal-text">
        Manage files for <strong>{{ currentUploadCompany?.company }}</strong>
      </p>

      <div class="existing-files-container" *ngIf="currentUploadCompany?.files?.length">
        <h3>Currently Attached</h3>
        <div class="file-list">
          <div class="file-item" *ngFor="let file of currentUploadCompany?.files; let i = index">
            <a [href]="file.url" target="_blank" class="file-link" [title]="file.name">{{ file.name }}</a>
            <button class="delete-file-btn" (click)="deleteFile(i)" title="Delete" [disabled]="deletingFileIndex === i || uploadingFile">
              <span *ngIf="deletingFileIndex === i">...</span>
              <span *ngIf="deletingFileIndex !== i">&times;</span>
            </button>
          </div>
        </div>
      </div>
      
      <input type="file" id="companyFileUploadInput" class="file-input" multiple (change)="onFileSelected($event)" [disabled]="uploadingFile">

      <div *ngIf="uploadingFile" class="uploading-container">
        <div class="uploading-header">
          <span>Uploading...</span>
          <span>{{ uploadProgress }}%</span>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" [style.width.%]="uploadProgress"></div>
        </div>
      </div>

      <div *ngIf="uploadedFileUrl" class="upload-success-msg">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
        Successfully uploaded!
      </div>

      <div class="modal-actions" style="margin-top: 1.5rem;">
        <button class="secondary-btn" (click)="closeUploadModal()" [disabled]="uploadingFile">Close</button>
        <button class="primary-btn" (click)="uploadFile()" [disabled]="selectedFiles.length === 0 || uploadingFile">
          {{ uploadingFile ? 'Uploading...' : 'Upload File' }}
        </button>
      </div>
    </div>
  </div>
</div>
